import React, { Component } from 'react';
import styled from 'styled-components';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { Column, Row } from '@zocdoc-frontend-common/styles-grid';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { Metrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { blue100, slate40 } from '@zocdoc-mezzanine/foundations-colors';
import { APPOINTMENT_INFO_STRINGS } from '../../pages/AppointmentInfo/constants';
import AppointmentTimeBlock from '../AppointmentTimeBlock';

const TitleRow = styled(FormRow)`
    font: 24px/32px ${FontFamily.SharpSansBold};
    color: ${blue100};
    margin-bottom: 12px;
`;

const SubTitleRow = styled(FormRow)`
    border-bottom: 1px solid ${slate40};
    padding-bottom: 24px;
    font: 15px/24px ${FontFamily.SharpSansSemibold};
    color: ${blue100};
`;

const MobileOnly = styled(Column).attrs({ size: 24 })`
    margin-bottom: 12px;
    margin-left: -16px;
    width: calc(100% + 32px);
    float: none !important;

    ${breakpoint.small} {
        display: none;
    }
`;

const DesktopOnly = styled.div`
    display: none;
    margin-bottom: 20px;

    ${breakpoint.small} {
        display: block;
    }
`;

/**
 * @param {Object} appointmentTime
 * @param {string} insuranceCarrierId
 * @param {string} insurancePlanId
 * @param {boolean} isNewPatient
 * @param {string} locationId
 * @param {function(): void} onClickContinue
 * @param {function(timeslot: Object, e: Object): void} onTimeSlotClicked
 * @param {string} procedureId
 * @param {string} professionalName
 * @param {string} providerId
 * @param {function(): void} trackViewedRescheduleModal
 * @returns {JSX.Element}
 * @constructor
 */
export default class RescheduleTimeFormView extends Component {
    state = {};

    componentDidMount() {
        this.props.trackViewedRescheduleModal();
    }

    render() {
        const {
            insuranceCarrierId,
            insurancePlanId,
            isNewPatient,
            locationId,
            onClickContinue,
            onTimeSlotClicked,
            procedureId,
            professionalName,
            providerId,
            appointmentTime,
        } = this.props;

        const appointmentTimeBlockProps = {
            insuranceCarrierId,
            insurancePlanId,
            isNewPatient,
            isReschedule: true,
            locationId,
            onTimeSlotClicked: (timeslot, event) => {
                onTimeSlotClicked(timeslot, event);
                onClickContinue();
            },
            procedureId,
            providerId,
            showTimesGrid: true,
        };

        const professionalNameText =
            professionalName === 'Professional Name'
                ? ''
                : ` with ${professionalName}`;

        return (
            <div>
                <Metrics section="RescheduleTimeForm">
                    <TitleRow data-test="reschedule-modal">
                        {APPOINTMENT_INFO_STRINGS.RescheduleTitle}
                    </TitleRow>
                    <SubTitleRow>
                        {`${appointmentTime.date} at ${appointmentTime.time}${professionalNameText}`}
                    </SubTitleRow>
                    <DesktopOnly data-test="desktop-timesgrid-container">
                        <Row>
                            <AppointmentTimeBlock
                                {...appointmentTimeBlockProps}
                                isMobile={false}
                            />
                        </Row>
                    </DesktopOnly>
                    <MobileOnly data-test="mobile-timesgrid-container">
                        <Row>
                            <AppointmentTimeBlock
                                {...appointmentTimeBlockProps}
                                isMobile
                            />
                        </Row>
                    </MobileOnly>
                </Metrics>
            </div>
        );
    }
}
